(function () {
	'use strict';
	angular.module('app.setup')
        .controller('dataPipelineHealthCheckTrend', dataPipelineHealthCheckTrend);
        
	dataPipelineHealthCheckTrend.$inject = ['$rootScope', '$scope', '$location', '$timeout', '$experiments', 'columnsService', 'leanFilterService', 'tableService'];

	function dataPipelineHealthCheckTrend($rootScope, $scope, $location, $timeout, $experiments, columnsService, leanFilterService, tableService) {
    
		var vm = this;
		vm.useReactReport = false;

		$scope.reportSettingsName = 'data-pipeline-health-check-trend';
		$scope.factoryNdx = $location.search().factoryNdx;
		$scope.summaryHref = '/application/f/home.html#/setup/data-pipeline';
		$scope.factoryHref = '/application/f/home.html#/setup/data-pipeline-history?&factoryNdx=' + $scope.factoryNdx;
		$scope.factoryAlias = globalConfig.user.authFacts[$scope.factoryNdx].alias;
		$scope.pageTitle = 'Health check trend: ' + $scope.factoryAlias;

		$timeout(function(){
			jQuery('li.list-group-item.selected').removeClass('selected');
			jQuery('#supplyChainDataPipeline').addClass('selected');
		}, 0);

		init();

		function init() {
			leanFilterService.clearFilters();
		}
	}
})();
